import './App.less';
import ContactUs from './Model/ConatctUs';
import Footer from './Model/Footer';
import Header from './Model/Header';
import Testimonials from './Model/Testimonials';
import logo from './logo.jpeg'
import { useNavigate } from 'react-router-dom';
import ImageShow from './Model/ImageShow';
import MyServicesBox from './Model/MyServiceBox';

function MyServices() {
  const navigate = useNavigate();
  const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      { name: 'Home', link: '/', onClick: () => navigate('/') },
      { name: 'About', link: '/aboutus', onClick: () => navigate('/aboutus') },
      {
        name: 'Gallery',
        link: '/gallery',
        children: [
          {
            name: 'Custom Build',
            link: '/gallery/custom-built',
            onClick: () => navigate('/know')
          },
          {
            name: 'Home Design',
            link: '/gallery/home-design',
            onClick: () =>  navigate('/custom')
          },
          {
            name: 'Knock Down Rebuild',
            link: '/gallery/knockdown-rebuilt',
            onClick: () =>  navigate('/comingsoon')
          },
          {
            name: 'Townhouses',
            link: '/gallery/townhouses',
            onClick: () =>  navigate('/gallery')
          }
        ]
      },
      { name: 'Contact', link: '/contact', onClick: () => navigate('/contact') }
    ]
  };

const Brand = "Aspire Homes"
return (
  <>
    <Header {...headerConfig} />
    <ImageShow  image="/images/app/contact.png" title="Service" />
    <MyServicesBox id="services" />
    <Testimonials id="testimonials" />
    <ContactUs id="contact" />
    <Footer />
  </>
);

};


export default MyServices;
